module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-contact-circle-e317ceb63136df541b41a2eee941056a.svg";